(() => {
  const get_variants = (container) => {
    const script = container.querySelector('variant-selects script[type="application/json"]');
    if (!script) {
      const globalScript = document.querySelector('variant-selects script[type="application/json"]');
      if (!globalScript) return [];
      try {
        return JSON.parse(globalScript.textContent);
      } catch (e) {
        return [];
      }
    }
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  };

  const get_selected_options = (container) => {
    const selects = container.querySelectorAll('.select__select');
    return Array.from(selects).map(s => s.value);
  };

  const find_variant = (variants, selected_options) => {
    return variants.find(v => {
      if (!v.options || v.options.length !== selected_options.length) return false;
      return v.options.every((opt, i) => opt === selected_options[i]);
    });
  };

  const get_container = (element) => {
    return element.closest('product-info')
      || element.closest('.product')
      || element.closest('form[action^="/cart/add"]')?.parentElement
      || document;
  };

  const process_variant = (select_element) => {
    const container = get_container(select_element);
    const variants = get_variants(container);
    const selected_options = get_selected_options(container);
    const variant = find_variant(variants, selected_options);

    if (!variant) {
      console.log('Variante no encontrada para:', selected_options);
      return;
    }
    console.log('Variante selected:', variant.title);
    console.log('Available:', variant.available);
    console.log('Price:', variant.price / 100);
    console.log(variant);

    const target = container.querySelector('.message-stock');
    const productDiv = document.querySelector('.product-div');
    if (!target) {
      console.log('No se encontró .message-stock en este contenedor');
      return;
    }

    if (variant.available) {

      const message = productDiv.getAttribute('data-message');
      const html_stock = `
      <div class="message-stock-available">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
          <circle cx="5.5" cy="5.5" r="5.5" fill="#45CE77"/>
        </svg>
        <span>${message}</span>
      </div>`;
      target.innerHTML = html_stock;
      container.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
        form.classList.remove('hide-formcart');
      });
    } else {
      const message = productDiv.getAttribute('data-messagestock');
      const html_stock = `<button type="submit" name="add" class="button button--full-width button--secondary product-form__submit_notify">
                        <span>${message}</span>
                        <div class="loading-overlay__spinner hidden">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                      </button>`;
      target.innerHTML = html_stock;
      container.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
        form.classList.add('hide-formcart');
      });
    }
  };

  document.addEventListener('click', function (e) {
    const notifyBtn = e.target.closest('.product-form__submit_notify');
    if (!notifyBtn) return;

    const klaviyoBtn = document.querySelector('.klaviyo-bis-trigger');
    if (klaviyoBtn) {
      klaviyoBtn.click();
    }
  });

  const handle_change = (event) => {
    process_variant(event.target);
  };

  const init_select = (target_select) => {
    if (target_select.dataset.stockInitialized === 'true') return;
    target_select.dataset.stockInitialized = 'true';

    const container = get_container(target_select);

    const target_quantity = container.querySelector('.product-form__quantity');
    if (target_quantity && !container.querySelector('.message-stock')) {
      target_quantity.insertAdjacentHTML('beforeend', '<div class="message-stock"></div>');
    }

    target_select.addEventListener('change', handle_change);
    process_variant(target_select);

  };

  const run_code = () => {
    document.querySelectorAll('.select__select').forEach(init_select);

    const observer = new MutationObserver(() => {
      const selects = document.querySelectorAll('.select__select:not([data-stock-initialized="true"])');
      selects.forEach(init_select);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run_code);
  } else {
    run_code();
  }
})();